import { requestPost } from '@/common/request';

interface ResultData {
  data: any;
}

interface reqParams {
  messageTypeConfigParamList?: MessageTypeConfigParam[];
}

type MessageTypeConfigParam = {
  channelType: number; //渠道 1-接收邮件通知 2-接收京me通知 3-京麦 4-消息中心 5-京东语音 6-VC
  messageType: number; //	消息类型，1-待报名，2-被驳回，3-待缴费，4-资源更新，5-审核通过，6-待审核，7-异常情况通知，8-数据导出，9-商家参与情况，10-其他重要通知
  isReceive: number; //	1开启 0关闭
};

/**
 * 消息中心-更新消息通知开关状态
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1306832381
 */
export default function genericMsgSwitchStatus(query: reqParams): Promise<RequestResult<ResultData>> {
  return requestPost('/generic/platMktMsgBk/message/saveMessageTypeConfig', query);
}
